<div 
    id="notification" 
    [class.active]="notification.active" 
    [class.error]="notification.status === 'error'" 
    [innerHTML]="notification.content"
></div>
